SupportLocationElementTemplate = require '../../../../location_element_view.html.mustache'
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormUSLocationElementView extends Backbone.View

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.support'
    @template = SupportLocationElementTemplate
    _.bindAll.apply(_, [this].concat(_.functions(this)))

  events:
    'change .add':'onChangeSelection'

  render: ->
    @$el.html toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    locObj = @options.location
    if locObj.isSelected
      locObj.checked = "checked"
    else
      locObj.checked = ""
    locObj.address = "#{locObj.streetAddress1},#{locObj.city},#{locObj.state},#{locObj.postalCode}"
    locObj

  onChangeSelection: ->
    @options.location.isSelected = !@options.location.isSelected
    @options.cb.call()

module.exports = EmailFormUSLocationElementView
